import axios from 'axios';
import { TIMEOUT_GLOBAL } from './constants';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: TIMEOUT_GLOBAL,
});

export const configureApi = ({ store, persistor }) => {
  api.interceptors.request.use((config) => {
    const state = store.getState();
    if (state.auth && state.auth.user) {
      config.headers.Authorization = `Bearer ${state.auth.user.token}`;
    }

    return config;
  });

  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      const isUnauthorized = error.response && error.response.status === 401;
      const hasAuthenticatedUser = Boolean(store.getState().auth?.user);

      if (isUnauthorized && hasAuthenticatedUser) {
        store.dispatch({ type: 'auth/removeToken' });

        try {
          await persistor.flush();
        } finally {
          if (window.location.pathname !== '/login') {
            window.location.replace('/login');
          }
        }
      }

      return Promise.reject(error);
    }
  );
};

export default api;
